export default function survey() {
  return `{
  survey {
    id
    title
    description
    startDate
    endDate
  }
}`;
}
